<template>
  <div v-if="visible" class="py-2 px-4 text-base">
    <div class="relative rounded-md bg-red-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <icon set="solid" name="x-circle" class="h-5 w-5 text-red-400" />
        </div>
        <div class="ml-3 space-y-2">
          <h3 class="text-sm leading-5 font-medium text-red-800">
            <div class="whitespace-pre">
              The following SKUs are restricted in {{ shipState }}:
            </div>
            <div class="whitespace-pre-line">
              {{ restrictedItems.join() }}
            </div>
            <div class="whitespace-pre">These SKUs cannot be reshipped</div>
          </h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StateRestrictionError",
  props: {
    shipState: {
      type: String
    },
    restrictedItems: {
      type: Array
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.visible = this.restrictedItems?.length > 0;
  },
  methods: {}
};
</script>
